class FixedAspectRatioImg {
	img: HTMLImageElement;
	aspectRatio = 1;
	width: number;
	height: number;

	constructor(img: HTMLImageElement) {
		this.img = img;
		this.width = Number.parseInt(<string>this.img.getAttribute("width"));
		this.height = Number.parseInt(<string>this.img.getAttribute("height"));
		this.aspectRatio = this.height / this.width;
	}
	/**
	 * @return {number}
	 */
	getRealHeight() {
		return Math.round(this.img.offsetWidth * this.aspectRatio);
	}

}

export default FixedAspectRatioImg;
